import React from 'react';
import { X } from 'lucide-react';

const ProjectModal = ({ project, isOpen, onClose }) => {
  if (!isOpen || !project) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Extended project details
  const getExtendedDetails = (projectId) => {
    const details = {
      1: {
        scope: "Comprehensive landscape design and implementation for student accommodation facilities across Main and San campuses",
        highlights: [
          "Native plant species selection for sustainability",
          "Water-efficient irrigation system design",
          "Green spaces for student recreation and wellbeing",
          "Hardscape pathways and gathering areas"
        ]
      },
      2: {
        scope: "Complete landscape transformation for ALDAR's Saadiyat Island site office, creating a professional and welcoming environment",
        highlights: [
          "Premium palm tree installation and maintenance",
          "Native shrub and tree planting for shade",
          "Advanced drip irrigation systems",
          "Decorative stone features and modern hardscaping"
        ]
      },
      3: {
        scope: "Full-scale park development including recreational facilities, landscaping, and infrastructure for Presidential Court",
        highlights: [
          "1.5km jogging track with lighting",
          "Children's play equipment installation",
          "Premium grass installation and maintenance",
          "Hardscape pavilions and seating areas"
        ]
      },
      4: {
        scope: "Specialized landscape works for Phase 2 of the Grand Mosque's Ramadan majles facilities",
        highlights: [
          "Advanced irrigation network installation",
          "Planting mounds with native species",
          "Softscape integration with existing architecture",
          "Seasonal tree and grass planting"
        ]
      },
      5: {
        scope: "Complete irrigation and softscape development for the Joko Widodo Mosque complex",
        highlights: [
          "Water-efficient irrigation systems",
          "Native tree and shrub selection",
          "Landscape integration with religious architecture",
          "Low-maintenance garden design"
        ]
      },
      6: {
        scope: "Sophisticated landscape and interior plant installation for ECSSR's premier training facility",
        highlights: [
          "Artificial landscape solutions for indoor areas",
          "Premium indoor plant selection and placement",
          "Maintenance programs for year-round excellence",
          "Integration with modern architectural elements"
        ]
      }
    };
    return details[projectId] || { scope: project.description, highlights: [] };
  };

  const extended = getExtendedDetails(project.id);

  return (
    <div className="modal-backdrop" data-testid="project-modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-container" data-testid="project-modal-container">
        <button onClick={onClose} className="modal-close" data-testid="project-modal-close-btn" aria-label="Close">
          <X className="w-6 h-6" />
        </button>

        <div className="modal-content">
          {/* Project Image */}
          <div className="modal-image-wrapper">
            <img 
              src={project.image} 
              alt={project.title}
              className="modal-image"
            />
            <div className="modal-image-overlay">
              <span className="modal-category">{project.category}</span>
            </div>
          </div>

          {/* Project Details */}
          <div className="modal-details">
            <h2 className="modal-title">{project.title}</h2>
            
            <div className="modal-client">
              <span className="modal-label">Client:</span>
              <span className="modal-client-name">{project.client}</span>
            </div>

            <div className="modal-section">
              <h3 className="modal-section-title">Project Scope</h3>
              <p className="modal-description">{extended.scope}</p>
            </div>

            {extended.highlights.length > 0 && (
              <div className="modal-section">
                <h3 className="modal-section-title">Key Highlights</h3>
                <ul className="modal-highlights">
                  {extended.highlights.map((highlight, index) => (
                    <li key={index} className="modal-highlight-item">
                      <span className="highlight-bullet"></span>
                      {highlight}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
